import { Delete, Edit, ReportProblem } from "@mui/icons-material";
import { Alert, Box, IconButton, Typography } from "@mui/material";

// Componente FilePreview
const FilePreview = ({
  files,
  removeFile,
  setImgSelected,
  styles,
  sizeFull,
  MAX_SIZE_MB_DEFAULT,
}) => (
  <Box sx={{ mt: 1 }}>
    {sizeFull >= 0.85 * MAX_SIZE_MB_DEFAULT && (
      <Alert severity="warning" sx={{ mb: 1 }}>
        Capacidade máxima de arquivos enviados está próximo do limite! ( Limite:
        1 MB. Soma atual: {sizeFull.toFixed(3)} MB)
      </Alert>
    )}
    <Typography variant="subtitle2" gutterBottom>
      Imagens Selecionadas ({files.length}) | {sizeFull.toFixed(3)} MB
    </Typography>
    <Box sx={styles.previewGrid}>
      {files.map((file, index) => (
        <FilePreviewItem
          key={index}
          file={file}
          index={index}
          removeFile={removeFile}
          setImgSelected={setImgSelected}
          styles={styles}
        />
      ))}
    </Box>
  </Box>
);

// Componente FilePreviewItem
const FilePreviewItem = ({
  file,
  index,
  removeFile,
  setImgSelected,
  styles,
}) => (
  <Box
    sx={{
      ...styles.previewItem,
      ...{ boxShadow: file.error ? "0 0 14px red" : "none" },
    }}
  >
    <img src={file.src} alt={file.name} style={styles.previewImage} />
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        removeFile(index);
      }}
      sx={styles.deleteButton}
    >
      <Delete fontSize="small" />
    </IconButton>
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        setImgSelected({ ...file, index });
      }}
      sx={styles.editButton}
    >
      <Edit fontSize="small" />
    </IconButton>

    {file.error && <ReportProblem sx={styles.errorIcon} />}
    <Typography variant="caption" sx={styles.fileName}>
      {file.name}
    </Typography>
  </Box>
);
export { FilePreview, FilePreviewItem };
